<div class="card-wrap">
    <div class="card-inner">
  
      <div class="brand">
        <span class="brand-k">K</span><span class="brand-rest">onvac</span>
      </div>
      <p class="tagline">Set your password</p>
      <p class="sub-text">
        Welcome! You're logging in as <strong>{{ email }}</strong>.
        Please set a permanent password to continue.
      </p>
  
      <form (ngSubmit)="onSubmit()" novalidate autocomplete="off">
  
        <div class="field-group">
          <label class="field-label">New password</label>
          <div class="input-wrap">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <input [type]="showNew ? 'text' : 'password'" class="field-input"
                   placeholder="Min. 8 characters"
                   [(ngModel)]="newPassword" name="newPassword" required autocomplete="new-password"/>
            <button type="button" class="toggle-pw" (click)="showNew = !showNew">
              <svg *ngIf="!showNew" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showNew" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
        </div>
  
        <div class="field-group">
          <label class="field-label">Confirm password</label>
          <div class="input-wrap">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <input [type]="showConfirm ? 'text' : 'password'" class="field-input"
                   placeholder="Repeat password"
                   [(ngModel)]="confirmPassword" name="confirmPassword" required autocomplete="new-password"/>
            <button type="button" class="toggle-pw" (click)="showConfirm = !showConfirm">
              <svg *ngIf="!showConfirm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showConfirm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
          <p class="hint-msg" *ngIf="confirmPassword && !passwordsMatch">Passwords do not match.</p>
        </div>
  
        <p class="error-msg" *ngIf="errorMessage">{{ errorMessage }}</p>
  
        <button type="submit" class="login-btn" [class.loading]="loading" [disabled]="!formValid || loading">
          <span class="btn-text" *ngIf="!loading">Set password &amp; continue</span>
          <span class="spinner" *ngIf="loading">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <circle cx="12" cy="12" r="10" stroke-opacity=".25"/>
              <path d="M12 2a10 10 0 0 1 10 10"/>
            </svg>
          </span>
        </button>
  
      </form>
  
      <button type="button" class="back-link" (click)="onBack()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
        </svg>
        Back to login
      </button>
  
    </div>
  </div>